import React from 'react';
import { Link } from 'react-router-dom';
import { Gauge, Monitor, ListTodo, BarChart3, Bell } from 'lucide-react';
import { cn } from '@/shared/lib/utils';
import { useSidebarContext } from '@/app/layouts/layout-context';

interface SidebarItemProps {
  title: string;
  icon: string;
  href?: string;
  isActive?: boolean;
  iconColor?: string;
}

const getIconComponent = (iconName: string) => {
  const iconMap: Record<string, React.ReactNode> = {
    'fa-tachometer': <Gauge className="w-4 h-4" />,
    'fa-desktop': <Monitor className="w-4 h-4" />,
    'fa-tasks': <ListTodo className="w-4 h-4" />,
    'fa-bar-chart': <BarChart3 className="w-4 h-4" />,
    'fa-bell': <Bell className="w-4 h-4" />,
  };
  return iconMap[iconName] || <div className="w-4 h-4" />;
};

export const SidebarItem: React.FC<SidebarItemProps> = ({
  title,
  icon,
  href,
  isActive = false,
  iconColor,
}) => {
  const { setCollapsed } = useSidebarContext();

  const handleClick = () => {
    if (window.innerWidth < 768) {
      setCollapsed();
    }
  };

  const content = (
    <div
      onClick={handleClick}
      className={cn(
        'flex items-center gap-4 w-full min-h-11 px-4 py-3 rounded-lg',
        'cursor-pointer transition-all duration-150 ease-in-out',
        'active:scale-98',
        isActive 
          ? 'bg-primary-100 text-primary-600' 
          : 'hover:bg-default-100 text-default-600'
      )}
    >
      <div 
        className={cn(
          'w-4 h-4 flex items-center justify-center',
          iconColor || (isActive ? 'text-primary-600' : 'text-default-400')
        )}
      >
        {getIconComponent(icon)}
      </div>
      <span 
        className={cn(
          'font-normal text-base',
          isActive ? 'text-primary-600' : 'text-default-600'
        )}
      >
        {title}
      </span>
    </div>
  );

  if (href) {
    return (
      <Link to={href} className="text-default-600 max-w-full">
        {content}
      </Link>
    );
  }

  return content;
};